import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SectionSplitProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types
};

const defaultProps = {
  ...SectionSplitProps.defaults
};

class HeroSplit extends React.Component {
  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'hero section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'hero-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const splitClasses = classNames(
      'split-wrap',
      invertMobile && 'invert-mobile',
      invertDesktop && 'invert-desktop',
      alignTop && 'align-top'
    );

    return (
      <section {...props} className={outerClasses}>
        <div className="container">
          <div className={innerClasses}>
            <div className={splitClasses}>
              <div className="split-item">
                <div className="hero-content split-item-content center-content-mobile reveal-from-top">
                  <h1 className="mt-0 mb-16">
                    Ask Your WooCommerce Store Questions in Plain English
                  </h1>
                  <p className="mt-0 mb-24">
                    Exanta lets store owners and administrators get instant answers from their WooCommerce data
                    {' '}no reports, spreadsheets, or SQL required. Just ask a question and get an answer.
                  </p>
                  <p className="mt-0 mb-32 text-sm text-color-low">
                    Works directly with your WooCommerce store - no technical setup required.
                  </p>
                  <ButtonGroup>
                    <Button tag={Link} color="primary" to="/account" wideMobile>
                      Install Exanta
                    </Button>
                    <Button tag="a" color="dark" href="#tutorials" wideMobile>
                      View Demo
                    </Button>
                  </ButtonGroup>
                </div>

                <div className="hero-figure split-item-image split-item-image-fill illustration-element-01 reveal-from-bottom">
                  <Image
                    src={require('./../../assets/images/hero-image-placeholder.png')}
                    alt="Illustration of Exanta answering WooCommerce store questions"
                    width={528}
                    height={396}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

HeroSplit.propTypes = propTypes;
HeroSplit.defaultProps = defaultProps;

export default HeroSplit;